import affiliateHeader from "../../Assets/support/Affiliate_Partners.jpg";
import QuestionComp from "../../components/Questions/QuestionComp";
import Unaswered from "../../components/Questions/Unanswered";
const AffiliatesPartner = ()=>{

    return(
        <>
         <div
        className="heroSection"
        style={{ backgroundImage: "url(" + affiliateHeader + ")" }}
      >
        <div className="container">
          <div className="row">
            <h1 className="text-center text-light head">
           
            </h1>
            <p className="text-center text-light pTag">
           
            </p>
          </div>
        </div>
        <br />
      </div>
      {/* <div className="textSection">
        <div className="container">
          <br />
          <h1 className="color">
          Page coming soon! 
          </h1>
          <p className="mt-3 bottom-text">
         
          </p>
        </div>
      </div> */}
      {/* <QuestionComp 
      heading={"Interested by the possibilities??"}
      paragraph={"We’d love to show you more. Just get in touch with your questions or to request a no-obligation demo."}
      button={"Show me more SchoolSmart"}
      /> */}
      <Unaswered/>
        </>
    )
}

export default AffiliatesPartner